import Cookies from 'js-cookie'

import {fetchList} from '@/api/shoppingCart'
import {PointscartList} from '@/api/integralShop'
import {getMsgCount} from '@/api/login'

const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      withoutAnimation: false
    },
    device: 'desktop',
	count: 0,
  msgCount: 0,
  openValue: true,
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    CART_NUM: (state, num) => {
      state.count = num
    },
  },
  actions: {
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    },
    CloseSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    ToggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },

    async changeCount({ commit, state }){
      const res = await fetchList();
      const point = await PointscartList();
      let total = 0;
      try {
        switch (res.status) {
          case 200:
            total = res.data.data.length;
            break;
        }
        switch (point.status) {
          case 200:
            total += point.data.data.data.length;
            break;
        }
        commit('CART_NUM', total)
        // state.count = total;

        // return total;
      } catch (e) {
        console.log(e);
      }
    },

  // async getMsgCount() {
  //   const res = await getMsgCount();
  //   let msgCount = 0;
  //   if (res.stauts == 200) {
  //     state.msgCount = res.data.data.number;
  //   } else {
  //     console.info(111)
  //   }
  // }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js